export const getMedianExpression = (rowRange: string, startWithEqual = true): string =>
  startWithEqual ? `=MEDIAN(FILTER_ENABLED(${rowRange}))` : `MEDIAN(FILTER_ENABLED(${rowRange}))`;
export const getMeanExpression = (rowRange: string, startWithEqual = true): string =>
  startWithEqual ? `=MEAN(FILTER_ENABLED(${rowRange}))` : `MEAN(FILTER_ENABLED(${rowRange}))`;

export const get75thPercentileExpression = (rowRange: string, startWithEqual = true): string =>
  startWithEqual
    ? `=PERCENTILE(FILTER_ENABLED(${rowRange}), 75)`
    : `PERCENTILE(FILTER_ENABLED(${rowRange}), 75)`;
export const get25thPercentileExpression = (rowRange: string, startWithEqual = true): string =>
  startWithEqual
    ? `=PERCENTILE(FILTER_ENABLED(${rowRange}), 25)`
    : `PERCENTILE(FILTER_ENABLED(${rowRange}), 25)`;

export const getCustomPercentileExpression = (rowRange: string, percentile: string, startWithEqual = true): string => {
  const percentileValue = percentile.replace(/\D/g, '');
  return startWithEqual
    ? `=PERCENTILE(FILTER_ENABLED(${rowRange}), ${percentileValue})`
    : `PERCENTILE(FILTER_ENABLED(${rowRange}), ${percentileValue})`;
};

export const getPreviousCellSameColumn = (key: string | undefined): string | null => {
  if (!key) {
    return null;
  }

  const match = /^([A-Za-z]+)(\d+)$/.exec(key);

  if (!match) {
    return null;
  }

  const [, column, rowNumber] = match;
  const row = Number(rowNumber);

  if (row <= 1) {
    return null;
  }

  return `${column}${row - 1}`;
};
